export default "__VITE_ASSET__D0PSt4qy__"